import { ConnexionPageState } from "../ConnexionPageState";
import { ConnexionPageResetPassword } from "./ConnexionPageResetPassword";

/** Etat lors d'un mot de passe faible */
export class ConnexionPageWeakPassword extends ConnexionPageState{

    /** Ignore ("Skip") la phase de changement de mot de passe et finalise l'accès à la page d'accueil. */
    public async SignIn(): Promise<void> {
        if(this.context.SignInResult.HasConnection) {
            /** Si, il y a une base lié on redirige vers la page Master */
            this.context.Vue.GoMaster(this.context.SignInResult.Ik)
        } else {
            /** Si, il n'y a pas de base lié, nous affichons le selecteur de base  */
            this.context.ShowBddList = true;
        }
        /** Retire l'avertissement de sécurité */
        this.context.ShowWeakPasswordPolicy = false;
    }

    /** Demande le changement du mot de passe */
    public ResetPassword(): void {
        /** Ferme le formulaire de saisie de mot de passe */
        this.context.ShowPasswordForm = false;
        /** Ferme l'avertissement de sécurité */
        this.context.ShowWeakPasswordPolicy = false;
        /** Pré-rempli le champ de saisie de mots de passe oublié */
        this.context.LoginForgotPassword = this.context.Login;
        /** Ouvre le formulaire de réinitialisation du mot de passe */
        this.context.ShowResetPasswordForm = true;

        /** Changement d'état */
        this.context.State = new ConnexionPageResetPassword(this.context);
    }

    //#region CAS INGORE
    /** VOID */
    public async SendMail(): Promise<void> { /** Aucun mail à envoyer */ }

    /** VOID */
    public async Abord(): Promise<void> { /** Ne permet pas de retour en arrière */ }

    /** VOID */
    public About(): void { /** Non proposé à l'utilisateur */ }
    //#endregion CAS INGORE
}